import { render } from "./CommonMessageRestHomeTop.vue?vue&type=template&id=3f7dad85&scoped=true"
import script from "./CommonMessageRestHomeTop.vue?vue&type=script&lang=js"
export * from "./CommonMessageRestHomeTop.vue?vue&type=script&lang=js"

import "./CommonMessageRestHomeTop.vue?vue&type=style&index=0&id=3f7dad85&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7dad85"],['__file',"src/views/h5/common/home/components/top/CommonMessageRestHomeTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f7dad85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f7dad85', __exports__)) {
    api.reload('3f7dad85', __exports__)
  }
  
  module.hot.accept("./CommonMessageRestHomeTop.vue?vue&type=template&id=3f7dad85&scoped=true", () => {
    api.rerender('3f7dad85', render)
  })

}


export default __exports__